
























import Vue from 'vue'
import Personalization from './components/Personalization.vue'
import MigrationDate from './components/MigrationDate.vue'

const menus = [
  {value: 'personalization', label: 'page_theme_personalization'},
  {value: 'themeColor', label: 'page_theme_theme_color'},
  {value: 'menu', label: 'menu'},
  {value: 'migrationDate', label: 'page_theme_migration_date'}
]
export default Vue.extend({
  name: '',
  components: {
    Personalization,
    MigrationDate
  },
  data() {
    return {
      menus,
      currentMenu: {} as any,
      themeColor: ''
    }
  },
  methods: {
    changeItem(item: any) {
      this.currentMenu = item
    }
  }
})
